import { environmentHttpClient as httpClient } from "client/Api/httpClient";

enum HowToVideoStatus {
	Unwatched = 0,
	Watched = 1
}

interface HowToVideoModel {
	subject: string;
	title: string;
	description: string;
	youtubeId: string;
	status: HowToVideoStatus;
}

interface HowToVideoDialogModel {
	subject: string;
	title: string;
	description: string;
	youtubeId: string;
	status: HowToVideoStatus;
}

interface HowToFilterModel {
	status: HowToVideoStatus;
}

export interface HowToSetStatusModel {
	status: HowToVideoStatus;
	videoSubject: string;
}

interface HowToVideosListWithCountersModel {
	videos: HowToVideoModel[];
	unwatchedVideosCount: number;
	watchedVideosCount: number;
}

function getVideoList(filter: HowToFilterModel): Promise<HowToVideosListWithCountersModel> {
	return httpClient.get<HowToVideosListWithCountersModel>("Workspace/LiveInformation/HowTo", filter);
}

function setStatus(model: HowToSetStatusModel): Promise<void> {
	return httpClient.put<void>("Workspace/LiveInformation/HowTo/SetStatus", model);
}

export {
	HowToVideoStatus,
	type HowToVideoModel,
	type HowToVideoDialogModel,
	type HowToVideosListWithCountersModel,
	getVideoList,
	setStatus
};